import { useEffect, useRef } from "react";

const easeOut = (t) => 1 - Math.pow(1 - t, 3);

// Compteur animé (count-up) déclenché à l'entrée dans le viewport — sans framer-motion
export default function AnimatedCounter({ value, prefix = "", suffix = "", format, duration = 1.8, className = "", testid }) {
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const fmt = (v) => (format ? format(v) : `${prefix}${v.toLocaleString("fr-FR")}${suffix}`);
    let raf = 0;
    const io = new IntersectionObserver(
      (entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        io.disconnect();
        const t0 = performance.now();
        const tick = (t) => {
          const p = Math.min(1, (t - t0) / (duration * 1000));
          node.textContent = fmt(Math.round(easeOut(p) * value));
          if (p < 1) raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
      },
      { rootMargin: "-80px 0px" }
    );
    io.observe(node);
    return () => {
      io.disconnect();
      if (raf) cancelAnimationFrame(raf);
    };
  }, [value, duration, format, prefix, suffix]);

  return (
    <span ref={ref} className={className} data-testid={testid}>
      {format ? format(0) : `${prefix}0${suffix}`}
    </span>
  );
}
